// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const marbleOutcrop = defineModel({
  id: "marble-outcrop",
  batchId: "future",
  name: "Marble outcrop",
  tags: ["scenery","marble","outcrop","low-poly","age-of-mcp","future"],
  summary: "A vein of marble. Cut for prestige building and statuary, and burnt for lime.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.36, 0.26, 0.32), color: "#e8e9ec", position: [-0.06, 0.13, 0], rotation: [0.04, 0.2, 0.05] },
      { geometry: new THREE.BoxGeometry(0.28, 0.22, 0.26), color: "#d7d9dd", position: [0.22, 0.11, 0.08], rotation: [0.06, -0.3, -0.06] },
      { geometry: new THREE.BoxGeometry(0.24, 0.2, 0.22), color: "#e8e9ec", position: [-0.02, 0.34, -0.04], rotation: [0.08, 0.5, 0.04] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.16), color: "#c4c7cd", position: [0.16, 0.3, -0.06], rotation: [0.1, -0.2, 0.1] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.13), color: "#d7d9dd", position: [-0.02, 0.5, -0.02], rotation: [0.1, 0.3, 0.06] },
      { geometry: new THREE.BoxGeometry(0.28, 0.02, 0.06), color: "#a9adb5", position: [-0.06, 0.18, 0.14], rotation: [0.04, 0.2, 0.18] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.05), color: "#a9adb5", position: [-0.02, 0.38, 0.09], rotation: [0.08, 0.5, -0.22] },
      { geometry: new THREE.BoxGeometry(0.15, 0.02, 0.05), color: "#a9adb5", position: [0.2, 0.14, 0.18], rotation: [0.06, -0.3, 0.2] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#e8e9ec", position: [0.2, 0.04, -0.12], rotation: [0.3, 0.6, 0.2] },
      { geometry: new THREE.BoxGeometry(0.08, 0.06, 0.07), color: "#c4c7cd", position: [-0.2, 0.03, 0.13], rotation: [0.2, 0.8, 0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#d7d9dd", position: [0.05, 0.03, -0.2], rotation: [0.25, 0.4, 0.2] },
    ],
  animations: [],
});
